import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportIcon from '@mui/icons-material/Report';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { common } from '@mui/material/colors';
import type { SvgIconComponent } from '@mui/icons-material';

import { ButterCup, Christine, Neutrals, SemanticError } from '../../../core-components/theme/color-palette/colors';
import type { Severity } from '../types/domain.types';

export interface SeverityTone {
  readonly fg: string;
  readonly bg: string;
  readonly border?: string;
}

export const SEVERITY_TONE: Readonly<Record<Severity, SeverityTone>> = {
  EMERGENCY: { fg: common.white, bg: SemanticError[600] },
  MAJOR: { fg: Christine[900], bg: Christine[200] },
  MINOR: { fg: ButterCup[900], bg: ButterCup[100] },
  CAUTION: { fg: Neutrals[700], bg: Neutrals[50], border: Neutrals[300] },
};

export const SEVERITY_ICON: Readonly<Record<Severity, SvgIconComponent>> = {
  EMERGENCY: ReportIcon,
  MAJOR: ErrorOutlineIcon,
  MINOR: WarningAmberIcon,
  CAUTION: InfoOutlinedIcon,
};
